const middleware = {}

middleware['auth/index'] = require('../../../middleware/auth/index.ts')
middleware['auth/index'] = middleware['auth/index'].default || middleware['auth/index']

middleware['auth/schemes/oidc'] = require('../../../middleware/auth/schemes/oidc.ts')
middleware['auth/schemes/oidc'] = middleware['auth/schemes/oidc'].default || middleware['auth/schemes/oidc']

middleware['auth/schemes/vsm'] = require('../../../middleware/auth/schemes/vsm.js')
middleware['auth/schemes/vsm'] = middleware['auth/schemes/vsm'].default || middleware['auth/schemes/vsm']

middleware['handleEtkRoute'] = require('../../../middleware/handleEtkRoute.js')
middleware['handleEtkRoute'] = middleware['handleEtkRoute'].default || middleware['handleEtkRoute']

middleware['handleIndexRedirect'] = require('../../../middleware/handleIndexRedirect.js')
middleware['handleIndexRedirect'] = middleware['handleIndexRedirect'].default || middleware['handleIndexRedirect']

middleware['handleLocale'] = require('../../../middleware/handleLocale.js')
middleware['handleLocale'] = middleware['handleLocale'].default || middleware['handleLocale']

middleware['handleRouteAccess'] = require('../../../middleware/handleRouteAccess.js')
middleware['handleRouteAccess'] = middleware['handleRouteAccess'].default || middleware['handleRouteAccess']

middleware['handleRouteTracking'] = require('../../../middleware/handleRouteTracking.ts')
middleware['handleRouteTracking'] = middleware['handleRouteTracking'].default || middleware['handleRouteTracking']

middleware['handleWelcomeRedirect'] = require('../../../middleware/handleWelcomeRedirect.ts')
middleware['handleWelcomeRedirect'] = middleware['handleWelcomeRedirect'].default || middleware['handleWelcomeRedirect']

middleware['isLoggedIn'] = require('../../../middleware/isLoggedIn.ts')
middleware['isLoggedIn'] = middleware['isLoggedIn'].default || middleware['isLoggedIn']

export default middleware
